import styled from '@emotion/styled';
import { Text } from '@hotjar/hotsauce';

export const Container = styled.div<{ isLoading?: boolean }>`
  display: flex;
  height: 100vh;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const Image = styled.img`
  width: 50%;
  align-self: center;
`;

export const TextWithLineBreak = styled(Text)`
  white-space: pre-line;
`;
